<template>
  <div v-if="$apollo.loading">
    <v-col cols="12" align="center" justify="center">
      <v-row align="center" justify="center">
        <v-text-field color="success" loading disabled></v-text-field>
      </v-row>
    </v-col>
  </div>
  <div v-else>
    <v-row v-if="secondaryCoachingPeriods == null || secondaryCoachingPeriods.length == 0">
      <v-col cols="12">
        <v-alert type="info" text>Set up your leave block on your <a href="/account/profile">Profile</a></v-alert>
      </v-col>
    </v-row>
    <v-row v-for="secondaryCoachingPeriod in secondaryCoachingPeriods" :key="secondaryCoachingPeriod.id">
      <v-col cols="12">
        <h2>Leave period: {{ secondaryCoachingPeriod.startDate }} - {{ secondaryCoachingPeriod.endDate }}</h2>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Client
                </th>
                <th class="text-left">
                  Assigned coach
                </th>
                <th class="text-left">
                  Added to WhatsApp
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in orderedClients(secondaryCoachingPeriod)" :key="item.id">
                <td>{{ formatUserName(item.node.subscription.user) }}</td>
                <td>
                  <v-row align="center">
                    <v-col cols="12" md="6">
                      <v-select
                        :items="coachList"
                        :value="item.node.secondaryCoach && item.node.secondaryCoach.id"
                        outlined
                        hide-details
                        dense
                        @change="handleProgramChange(item.node.id, $event, null)"
                      ></v-select>
                    </v-col>
                  </v-row>
                </td>
                <td>
                  <v-checkbox
                    v-model="item.node.addedToWhatsapp"
                    :ripple="false"
                    @change="handleProgramChange(item.node.id, null, $event)"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  ACTIVE_SECONDARY_COACHING_PERIODS,
  UPDATE_SECONDARY_COACH_MUTATION,
} from "@/constants/graphql/coach/clientManagement";
import { getUserName } from "@/lib/username";
import { decodeId } from "@/lib/string";

export default {
  name: "CoachingManageSecondarySubscription",
  props: {
    coachId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      secondaryCoachingPeriods: [],
      coachList: {},
    };
  },
  methods: {
    orderedClients(secondaryCoachingPeriod) {
      // prevents infinate loop
      let clients = [...secondaryCoachingPeriod.coachsecondaryuserprogramSet?.edges];
      return clients.sort((a, b) =>
        this.formatUserName(a.node.subscription.user) < this.formatUserName(b.node.subscription.user) ? -1 : 1
      );
    },
    formatUserName(user) {
      return getUserName(user);
    },
    handleProgramChange(secondaryCoachId, selectCoachEvent, addedToWhatsApp) {
      this.$apollo.mutate({
        mutation: UPDATE_SECONDARY_COACH_MUTATION,
        variables: {
          secondaryCoachId: secondaryCoachId ? decodeId(secondaryCoachId) : null,
          coachId: selectCoachEvent ? decodeId(selectCoachEvent) : null,
          addedToWhatsApp: addedToWhatsApp,
        },
        refetchQueries: ["secondaryCoachingPeriods"],
      });
    },
  },
  apollo: {
    secondaryCoachingPeriods: {
      query: ACTIVE_SECONDARY_COACHING_PERIODS,
      variables() {
        return {
          coachId: this.coachId,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.coachList = response.data.users.edges.map((coach) => {
            return { text: this.formatUserName(coach.node), value: decodeId(coach.node.id) };
          });
          this.coachList.unshift({ text: "No coach", value: null });
        }
      },
    },
  },
};
</script>
